import $ from 'jquery';
import mediator from '../mediator';

const shareButtons = $('.share-buttons');
const isFixed = () => shareButtons.hasClass('share-buttons-fixed');
const spacing = 72;
let wrap;
let wrapBCR;
let leftPos;
let updating;
let lastWinWidth;
let bottomOffset;
let shareButtonsOffset;
let heroOffset;
let heroHeight;
let topOffset;

const handleScroll = () => {
  const scrollTop = Math.max(
    window.pageYOffset,
    document.documentElement.scrollTop,
    document.body.scrollTop
  );
  const scrollOffset = scrollTop + shareButtons.height() + spacing;
  const $hero = $('.hero');
  const $relatedLinks = $('.related-links');
  bottomOffset = ($relatedLinks.length > 0) ? $relatedLinks.offset().top : $('.top-footer').offset().top;
  heroOffset = $hero.offset().top;
  heroHeight = $hero.outerHeight(true);
  topOffset = heroOffset + heroHeight;

  if (lastWinWidth < 1300) {
    shareButtons.css({ transform: '' });
    shareButtons.removeClass('share-buttons-fixed');
    updating = false;
    return false;
  }

  if (scrollTop < topOffset) {
    shareButtons.css({ transform: 'translate(-48px, 0px' });
    shareButtons.removeClass('share-buttons-fixed');
  } else if ((scrollOffset > bottomOffset) && isFixed()) {
    shareButtonsOffset = scrollTop - topOffset;
    shareButtons.css({ transform: `translate(-48px, ${shareButtonsOffset}px` });
    shareButtons.removeClass('share-buttons-fixed');
  } else if ((scrollOffset < bottomOffset) && !isFixed()) {
    shareButtons.css({ transform: `translate(${leftPos}px, 24px` });
    shareButtons.addClass('share-buttons-fixed');
  }

  updating = false;
};

/**
 * Callback for our scroll event - just
 * keeps track of the last scroll value
 * Checks if not already updating
 * rAF called with scroll handler function.
 */
const onScroll = () => {
  wrap = document.querySelector('#main-row-column');
  wrapBCR = wrap.getBoundingClientRect();
  leftPos = wrapBCR.left - 48;
  lastWinWidth = window.innerWidth;

  if (!updating) {
    requestAnimationFrame(handleScroll);
    updating = true;
  }
};

/**
 * Set initial positioning.
 */
const initPositioning = () => {
  shareButtons.addClass('share-buttons-set');
  if (window.innerWidth >= 1300) {
    shareButtons.css({ transform: 'translate(-48px, 0px' });
    onScroll();
  }
};

export default () => {
  const $hero = $('.hero');
  const $relatedLinks = $('.related-links');
  wrap = document.querySelector('#main-row-column');
  wrapBCR = wrap.getBoundingClientRect();
  leftPos = wrapBCR.left - 48;
  updating = false;
  lastWinWidth = 0;
  bottomOffset = ($relatedLinks.length > 0) ? $relatedLinks.offset().top : $('.top-footer').offset().top;
  shareButtonsOffset = bottomOffset - $('.share-buttons-set').height();
  heroOffset = $hero.offset().top;
  heroHeight = $hero.outerHeight(true);
  topOffset = heroOffset + heroHeight;

  initPositioning();
  window.addEventListener('scroll', onScroll);
  mediator.on('window:throttledResize', onScroll);
};



// WEBPACK FOOTER //
// ./node_modules/cigna-frontend/js/social/scroll-handler.js